// Thin fetch wrapper. Pages Functions live under /api, /auth, /webhooks.
// Session cookie is set HttpOnly by the server, so we just need credentials: "include".

export class ApiError extends Error {
  constructor(public status: number, message: string, public body?: unknown) {
    super(message);
  }
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(path, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...(init.headers ?? {}),
    },
    ...init,
  });
  const text = await res.text();
  const body: unknown = text ? safeJson(text) : null;
  if (!res.ok) {
    throw new ApiError(res.status, `Request failed: ${res.status}`, body);
  }
  return body as T;
}

function safeJson(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body: unknown) =>
    request<T>(path, { method: "POST", body: JSON.stringify(body) }),
  patch: <T>(path: string, body: unknown) =>
    request<T>(path, { method: "PATCH", body: JSON.stringify(body) }),
  delete: <T>(path: string) => request<T>(path, { method: "DELETE" }),
};

// Typed endpoints
export interface MeStreamer {
  overlay_key: string;
  bio: string | null;
  total_donations: number;
}
export interface MeFaction {
  id: string;
  slug: string;
  name: string;
  color: string;
}
export interface MeUser {
  id: string;
  handle: string;
  display_name: string;
  avatar_url: string | null;
  email?: string | null;
  is_creator: boolean;
  onboarded_at?: number | null;
  twitch_linked?: boolean;
  google_linked?: boolean;
  youtube_channel_id?: string | null;
}
export interface MeResponse {
  user: MeUser | null;
  streamer?: MeStreamer | null;
  factions?: MeFaction[];
}

export const getMe = () => api.get<MeResponse>("/api/me");
